import { Injectable, NgZone } from '@angular/core';
import { pythonServerApiKey } from './constant.service';
import { environment } from 'src/environments/environment';
import { retry, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { IndexedDBService } from './indexed-db.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { StorageService } from './storage.service';
import { AppService } from './app.service';
import { EndpointService } from './endpoint.service';
import { LazyLoadingService } from './lazy-loading.service';
import { HttpClient, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { OnlineOfflineService } from "./online-offline.service";
import { UtilVoicesService } from './util-voices.service';
declare const $: any;

declare var chrome: any;

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  private mobileVersion = '';
  public canClipboardPaste: boolean = false;

  constructor(
    public dialog: MatDialog,
    private http: HttpClient,
    private indexedDbService: IndexedDBService,
    private storageService: StorageService,
    private endpointService: EndpointService,
    private lazyLoadingService: LazyLoadingService,
    private onlineOfflineService: OnlineOfflineService,
    public voiceUtilService: UtilVoicesService,
    private ngZone: NgZone
  ) {
    this.canClipboardPaste = this.getCanClipboardPaste();
  }

  getCanClipboardPaste() {
    let isChrome = this.isChrome();
    let isOpera = this.isOpera();
    return isChrome || isOpera || AppService.isIOS() || AppService.isAndroid();
  }

  isSmallScreen() {
    return window.innerWidth <= 576;
  }

  restart() {
    if (AppService.isPW() || AppService.isAndroid() || AppService.isIOS()) {
      return new Promise(async (resolve) => {
        // localStorage.clear();
        this.storageService.clearLocalStorageExceptCommProjects();
        sessionStorage.clear();
        this.indexedDbService.clear();

        // clearing caches
        await this.clearCache();
        // clearing service workers
        /*
        navigator.serviceWorker.getRegistrations().then(function(registrations) {
          for (let registration of registrations) {
          registration.unregister()
          }
        });*/
        resolve(null);
      })
        .then(() => {
          if (AppService.isAndroid() || AppService.isIOS()) {
            window.location.replace("./index.html");
          } else {
            window.location.reload();
          }
        })
        .catch(err => {
          console.log(err);
        });
    } else if (AppService.isSoftware()) {
      return Promise.resolve()
        .then(async () => {
          localStorage.clear();
          sessionStorage.clear();
          // TODO this.indexedDbService.clear();
          await this.clearCache();
          // TODO: relaunch the app
          const ipcRenderer = (<any>window).nodeRequire('electron').ipcRenderer;
          console.log(ipcRenderer.sendSync('synchronous-message', 'relaunch'));
        })
        .catch((err) => {
          console.log("err sw restart", err);
        })

    }
  }

  async clearCache() {
    try {
      const keys = await window.caches.keys();
      console.log("cache keys", keys);
      await Promise.all(keys.map(key => caches.delete(key)));
    } catch (err) {
      console.log('clearCache err: ', err);
    }
  }

  public isChrome() {
    console.log("isChrome", /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor));
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  }

  public isEdge(): boolean {
    return /Edg/.test(navigator.userAgent);
  }

  public isOpera() {
    return /Opera|OPR\//.test(navigator.userAgent);
  }

  public chromeUndefined() {
    return typeof chrome === 'undefined'
  }

  public getSystem() {
    //return 'windows';
    //return 'mac';
    if (UtilService.isPC()) {
      const os = (<any>window).nodeRequire('os');
      if (os.platform() === 'darwin') {
        return 'mac';
      } else if (os.platform() === 'win32') {
        return 'windows';
      }
    }
    return 'cordova';
  }

  public static isPC() {
    const userAgentInfo = navigator.userAgent;
    const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  }

  public hasChromeRuntime() {
    if (typeof chrome !== 'undefined' && chrome && chrome.runtime)
      return true;

    return false;
  }

  public startWith(str, beginStr) {
    if (str.substr(0, beginStr.length) === beginStr) {
      return true;
    }
    return false;
  }

  public copyToClipboard(text) {
    const $temp = $('<input>');
    $('body').append($temp);
    $temp.val(text).select();
    document.execCommand('copy');
    $temp.remove();
  }

  public async textToPdf(text: string, token: string): Promise<any> {

    const url = this.getEndpoint('uploadOcrDomain') + '/texttopdf';

    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' });
    let params = new HttpParams();
    if (token !== '0') {
      params = params.set('userid', token);
    }
    params = params.set('text', text);
    params = params.set('apikey', pythonServerApiKey);

    return this.http.post(url, params, { headers })
      .pipe(
        retry(3),
        catchError(this.handleError)
      ).toPromise()
      .catch(err => {
        console.log(err);
      });
    // toPromise()
    //   .catch(err => {
    //     console.log(err);
    //   });
  }

  public roundTo2Decimals(num: number) {
    return Math.round((num + Number.EPSILON) * 100) / 100;
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  public getLanguageName2(lang: string, withLocation = true) {
    console.log("getLanguageName lang", lang);
    // if (lang.includes('en') && !lang.includes('US') && !lang.includes('UK') && !lang.includes('GB')) {
    //   if (withLocation) {
    //     return 'English (Others)';
    //   } else {
    //     return 'English';
    //   }
    // }
    switch (lang) {
      case 'multi':
        return 'Multi-Lingual';
      case 'en-scotland':
      case 'en_scotland':
        return withLocation ? 'English (Scotland)' : 'English';
      case 'en':
      case 'en-US':
      case 'en_US':
        return withLocation ? 'English (US)' : 'English';
      case 'en-CA':
      case 'en_CA':
        return withLocation ? 'English (Canada)' : 'English';
      case 'en-GB':
      case 'en_GB':
      case 'en-UK':
      case 'en_UK':
      case 'en-GB-oxendict':
      case 'en_GB_oxendict':
      case 'British':
        return withLocation ? 'English (UK)' : 'English';
      case 'en-CY':
      case 'en_CY':
        return withLocation ? 'English (Wales)' : 'English';
      case 'en-AU':
      case 'en_AU':
        return withLocation ? 'English (Australia)' : 'English';
      case 'en-IN':
      case 'en_IN':
        return withLocation ? 'English (India)' : 'English';
      case 'en-ZA':
      case 'en_ZA':
        return withLocation ? 'English (South Africa)' : 'English';
      case 'en-IE':
      case 'en_IE':
        return withLocation ? 'English (Ireland)' : 'English';
      case 'en-KE':
      case 'en_KE':
        return withLocation ? 'English (Kenya)' : 'English';
      case 'en-NZ':
      case 'en_NZ':
        return withLocation ? 'English (New Zealand)' : 'English';
      case 'es-ES':
      case 'es_ES':
        return withLocation ? 'Spanish (Spain)' : 'Spanish';
      case 'es-MX':
      case 'es_MX':
        return withLocation ? 'Spanish (Mexico)' : 'Spanish';
      case 'es-CA':
      case 'es_CA':
        return withLocation ? 'Spanish (Spain)' : 'Spanish';
      case 'es-AR':
      case 'es_AR':
        return withLocation ? 'Spanish (Argentina)' : 'Spanish';
      case 'de-DE':
      case 'de_DE':
        return 'German';
      case 'de-AT':
      case 'de_AT':
        return withLocation ? 'German (Austria)' : 'German';
      case 'de-CH':
      case 'de_CH':
        return withLocation ? 'German (Switzerland)' : 'German';
      case 'fr-FR':
      case 'fr_FR':
        return 'French';
      case 'es-US':
      case 'es_US':
        return withLocation ? 'Spanish (US)' : 'Spanish';
      case 'it-IT':
      case 'it_IT':
        return 'Italian';
      case 'pl-PL':
      case 'pl_PL':
        return 'Polish';
      case 'nl-NL':
      case 'nl_NL':
        return 'Dutch';
      case 'tr-TR':
      case 'tr_TR':
        return 'Turkish';
      case 'no-NO':
      case 'no_NO':
      case 'nb-NO':
        return 'Norwegian';
      case 'is-IS':
      case 'is_IS':
        return 'Icelandic';
      case 'da-DK':
      case 'da_DK':
        return 'Danish';
      case 'cy-GB':
      case 'cy_GB':
        return 'Welsh';
      case 'zh-CN':
      case 'zh_CN':
        return withLocation ? 'Chinese(Mandarin)' : 'Chinese';
      case 'zh-TW':
      case 'zh_TW':
        return withLocation ? 'Chinese (Mandarin, Taiwan)' : 'Chinese';
      case 'zh-HK':
      case 'zh_HK':
      case 'yue-HK':
      case 'yue_HK':
        return withLocation ? 'Chinese (Cantonese)' : 'Chinese';
      case 'ja-JP':
      case 'ja_JP':
        return 'Japanese';
      case 'ko-KR':
      case 'ko_KR':
      case 'ko':
        return 'Korean';
      case 'hi-HI':
      case 'hi_HI':
        return 'Hindi';
      case 'id-ID':
      case 'id_ID':
        return 'Indonesian';
      case 'ro-RO':
      case 'ro_RO':
        return 'Romanian'
      case 'ru-RU':
      case 'ru_RU':
        return 'Russian';
      case 'pt-BR':
      case 'pt_BR':
        return withLocation ? 'Portuguese (Brazil)' : 'Portuguese';
      case 'pt-PT':
      case 'pt_PT':
        return withLocation ? 'Portuguese (Portugal)' : 'Portuguese';
      case 'fr-CA':
      case 'fr_CA':
        return withLocation ? 'French (Canada)' : 'French';
      case 'fr-BE':
      case 'fr_BE':
        return withLocation ? 'French (Belgium)' : 'French';
      case 'fr-CH':
      case 'fr_CH':
        return withLocation ? 'French (Switzerland)' : 'French';
      case 'sv-SE':
      case 'sv_SE':
        return 'Swedish';
      case 'ar':
        return 'Arabic';
      case 'ar-SA':
      case 'ar_SA':
        return withLocation ? 'Arabic (Saudi Arabia)' : 'Arabic';
      case 'ar-AE':
      case 'ar_AE':
        return withLocation ? 'Arabic (U.A.E.)' : 'Arabic';
      case 'ar-EG':
      case 'ar_EG':
        return withLocation ? 'Arabic (Egypt)' : 'Arabic';
      case 'ar-LB':
      case 'ar_LB':
        return withLocation ? 'Arabic (Lebanon)' : 'Arabic';
      case 'ar-QA':
      case 'ar_QA':
        return withLocation ? 'Arabic (Qatar)' : 'Arabic';
      case 'ar-IQ':
      case 'ar_IQ':
        return withLocation ? 'Arabic (Iraq)' : 'Arabic';
      case 'ar-LY':
      case 'ar_LY':
        return withLocation ? 'Arabic (Libya)' : 'Arabic';
      case 'ar-YE':
      case 'ar_YE':
        return withLocation ? 'Arabic (Yemen)' : 'Arabic';
      case 'ar-SY':
      case 'ar_SY':
        return withLocation ? 'Arabic (Syria)' : 'Arabic';
      case 'cs-CZ':
      case 'cs_CZ':
        return withLocation ? 'Czech (Czech Republic)' : 'Czech';
      case 'el-GR':
      case 'el_GR':
        return withLocation ? 'Greek (Greece)' : 'Greek';
      case 'fi-FI':
      case 'fi_FI':
        return withLocation ? 'Finnish (Finland)' : 'Finnish';
      case 'he':
        return withLocation ? 'Hebrew' : 'Hebrew';
      case 'he-IL':
      case 'he_IL':
      case 'iw-IL':
      case 'iw_IL':
        return withLocation ? 'Hebrew (Israel)' : 'Hebrew';
      case 'hi-IN':
      case 'hi_IN':
        return withLocation ? 'Hindi (India)' : 'Hindi';
      case 'hu-HU':
      case 'hu_HU':
        return withLocation ? 'Hungarian (Hungary)' : 'Hungarian';
      case 'nb-NO':
      case 'nb_NO':
        return withLocation ? 'Norwegian (Bokm?l) (Norway)' : 'Norwegian';
      case 'nl-BE':
      case 'nl_BE':
        return withLocation ? 'Dutch (Belgium)' : 'Dutch';
      case 'sk-SK':
      case 'sk_SK':
        return withLocation ? 'Slovak (Slovakia)' : 'Slovak';
      case 'th-TH':
      case 'th_TH':
        return withLocation ? 'Thai (Thailand)' : 'Thai';
      case 'km-KH':
      case 'km_KH':
        return withLocation ? 'Khmer (Cambodia)' : 'Khmer';
      case 'in-ID':
      case 'in_ID':
        return withLocation ? 'Indonesian (Indonesia)' : 'Indonesian';
      case 'ne-NP':
      case 'ne_NP':
        return withLocation ? 'Nepali (Nepal)' : 'Nepali';
      case 'vi-VN':
      case 'vi_VN':
        return withLocation ? 'Vietnamese (Vietnam)' : 'Vietnamese';
      case 'si-LK':
      case 'si_LK':
        return withLocation ? 'Sinhala (Sri Lanka)' : 'Sinhala';
      case 'bn-BD':
      case 'bn_BD':
        return withLocation ? 'Bengali (Bangladesh)' : 'Bengali';
      case 'bn-IN':
      case 'bn_IN':
        return withLocation ? 'Bengali (India)' : 'Bengali';
      case 'uk-UA':
      case 'uk_UA':
        return withLocation ? 'Ukrainian (Ukraine)' : 'Ukrainian';
      case 'fil-PH':
      case 'fil_PH':
        return withLocation ? 'Filipino (Philippines)' : 'Filipino';
      case 'gu-IN':
      case 'gu_IN':
        return withLocation ? 'Gujarati (India)' : 'Gujarati';
      case 'te-IN':
      case 'te_IN':
        return withLocation ? 'Telugu (India)' : 'Telugu';
      case 'kn-IN':
      case 'kn_IN':
        return withLocation ? 'Kannada (India)' : 'Kannada';
      case 'ta-IN':
      case 'ta_IN':
        return withLocation ? 'Tamil (India)' : 'Tamil';
      case 'en-NG':
      case 'en_NG':
        return withLocation ? 'English (Nigeria)' : 'English';
      case 'ml-IN':
      case 'ml_IN':
        return withLocation ? 'Malayalam (India)' : 'Malayalam';
      case 'ur-PK':
      case 'ur_PK':
        return withLocation ? 'Urdu (Pakistan)' : 'Malayalam';
      case 'su-ID':
      case 'su_ID':
        return withLocation ? 'Sundanese (Indonesia)' : 'Sundanese';
      case 'et-EE':
      case 'et_EE':
        return withLocation ? 'Estonian (Estonia)' : 'Estonian';
      case 'jv-ID':
      case 'jv_ID':
        return withLocation ? 'Javanese (Indonesia)' : 'Javanese';
      case 'mr-IN':
      case 'mr_IN':
        return withLocation ? 'Marathi (India)' : 'Marathi';
      case 'bg-BG':
      case 'bg_BG':
        return withLocation ? 'Bulgarian (Bulgaria)' : 'Bulgarian';
      case 'bs-BA':
      case 'bs_BA':
        return withLocation ? 'Bosnian (Bosnia and Herzegovina)' : 'Bosnian';
      case 'lv-LV':
      case 'lv_LV':
        return withLocation ? 'Latvian (Latvia)' : 'Latvian';
      case 'ms-MY':
      case 'ms_MY':
        return withLocation ? 'Malay (Malaysia)' : 'Malay';
      case 'pa-IN':
      case 'pa_IN':
        return withLocation ? 'Punjabi (India)' : 'Punjabi';
      case 'sq-AL':
      case 'sq_AL':
        return withLocation ? 'Albanian (Albania)' : 'Albanian';
      case 'sw-KE':
      case 'sw_KE':
        return withLocation ? 'Swahili (Kenya)' : 'Swahili';
      case 'ca-ES':
      case 'ca_ES':
        return withLocation ? 'Catalan' : 'Catalan';
      case 'ga-IE':
      case 'ga_IE':
        return withLocation ? 'Irish' : 'Irish';
      case 'hr-HR':
      case 'hr_HR':
        return withLocation ? 'Croatian' : 'Croatian';
      case 'ka-GE':
      case 'ka_GE':
        return withLocation ? 'Georgian' : 'Georgian';
      case 'ur-IN':
      case 'ur_IN':
        return withLocation ? 'Urdu' : 'Urdu';
    }
    return lang;
  }

  public getLanguageName(lang: string, withLocation = true) {
    console.log("getLanguageName lang", lang);
    if (lang === 'multi') {
      return 'Multi-Lingual';
    }
    if (this.voiceUtilService.languageCodeToNameMapping[lang]) {
      let languageName = this.voiceUtilService.languageCodeToNameMapping[lang];
      if (withLocation) {
        return languageName;
      } else {
        return languageName.split('(')[0].trim();
      }
    }
    return lang;
  }

  public getLanguageAndLocaleForVoiceList(language) {
    let languageName = '';
    let localeName = this.getLocaleName(language);
    let displayLocale = true;
    if (language.includes('en')) {
      languageName = this.getLanguageName(language, true);
      if (!languageName.includes('Others')) {
        displayLocale = false;
      }
    } else {
      languageName = this.getLanguageName(language, false);
    }
    return { languageName, localeName, displayLocale };
  }

  public getLocaleName(lang: string) {
    let locale = '';
    if (lang.includes('-')) {
      locale = lang.split('-')[1];
    } else if (lang.includes('_')) {
      locale = lang.split('_')[1];
    }
    switch (locale) {
      case 'US':
        return 'US';
      case 'GB':
      case 'UK':
        return 'UK';
      case 'CA':
        if (lang.includes('es')) {
          return 'Spain';
        } else {
          return 'Canada';
        }
      case 'AU':
        return 'Australia';
      case 'CY':
        return 'Wales';
      case 'IN':
        return 'India';
      case 'ZA':
        return 'South Africa';
      case 'IE':
        return 'Ireland';
      case 'CN':
        return 'Mandarin';
      case 'TW':
        return 'Taiwanese';
      case 'HK':
        return 'Cantonese';
      case 'AE':
        return 'U.A.E';
      case 'SA':
        return 'Saudi Arabia';
      case 'EG':
        return 'Egypt';
      case 'LB':
        return 'Lebanon';
      case 'QA':
        return 'Qatar';
      case 'IQ':
        return 'Iraq';
      case 'LY':
        return 'Libya';
      case 'YE':
        return 'Yemen';
      case 'SY':
        return 'Syria';
      case 'BR':
        return 'Brazil';
      case 'PT':
        return 'Portugal';
      case 'IL':
        return 'Israel';
      case 'ES':
        return 'Spain';
      case 'MX':
        return 'Mexico';
      case 'AT':
        return 'Austria';
      case 'CH':
        return 'Switzerland';
      case 'BE':
        return 'Belgium';
      case 'FR':
        return 'France';
      case 'DE':
        return 'Germany';
      case 'SG':
        return 'Singapore';
      case 'KE':
        return 'Kenya';
      case 'NZ':
        return 'New Zealand';
      case 'PH':
        return 'Philippines';
      case 'TZ':
        return 'Tanzania';
      case 'AL':
        return 'Albania';
      case 'ET':
        return 'Ethiopia';
      case 'AM':
        return 'Armenia';
      case 'AZ':
        return 'Azerbaijan';
      case 'EU':
        return 'Basque';
      case 'IN':
        return 'Bengali';
      case 'BA':
        return 'Bosnia and Herzegovina';
      case 'BG':
        return 'Bulgaria';
      case 'MM':
        return 'Myanmar';
      case 'CA':
        return 'Catalan';
      case 'HR':
        return 'Croatia';
      case 'CZ':
        return 'Czech';
      case 'DK':
        return 'Denmark';
      case 'NL':
        return 'Netherlands';
      case 'EE':
        return 'Estonia';
      case 'FI':
        return 'Finland';
      case 'GL':
        return 'Galician';
      case 'GE':
        return 'Georgia';
      case 'GR':
        return 'Greece';
      case 'HU':
        return 'Hungary';
      case 'IS':
        return 'Iceland';
      case 'ID':
        return 'Indonesia';
      case 'IT':
        return 'Italy';
      case 'JP':
        return 'Japan';
      case 'JV':
        return 'Javanese';
      case 'KN':
        return 'Kannada';
      case 'KZ':
        return 'Kazakhstan';
      case 'KH':
        return 'Cambodia';
      case 'KR':
        return 'Korea';
      case 'LA':
        return 'Laos';
      case 'LV':
        return 'Latvia';
      case 'LT':
        return 'Lithuania';
      case 'MK':
        return 'North Macedonia';
      case 'MY':
        return 'Malaysia';
      case 'ML':
        return 'Malayalam';
      case 'MT':
        return 'Malta';
      case 'MN':
        return 'Mongolia';
      case 'NP':
        return 'Nepal';
      case 'NO':
        return 'Norway';
      case 'AF':
        return 'Afghanistan';
      case 'IR':
        return 'Iran';
      case 'PL':
        return 'Poland';
      case 'RO':
        return 'Romania';
      case 'RU':
        return 'Russia';
      case 'RS':
        return 'Serbia';
      case 'LK':
        return 'Sri Lanka';
      case 'SK':
        return 'Slovakia';
      case 'SI':
        return 'Slovenia';
      case 'SO':
        return 'Somalia';
      case 'SE':
        return 'Sweden';
      case 'TA':
        return 'Tamil';
      case 'TE':
        return 'Telugu';
      case 'TH':
        return 'Thailand';
      case 'TR':
        return 'Türkiye';
      case 'UA':
        return 'Ukraine';
      case 'PK':
        return 'Pakistan';
      case 'UZ':
        return 'Uzbekistan';
      case 'VN':
        return 'Vietnam';
      case 'ZU':
        return 'Zulu';
      default:
        return '';
    }
  }

  public getLocationAndLangName(lang: string) {
    switch (lang) {
      case 'fr-FR':
        return 'FrenchFrance';
      case 'fr-CA':
        return 'FrenchCanada';
      case 'fr-CH':
        return 'FrenchSwitzerland';
      case 'fr-BE':
        return 'FrenchBelgium';
      case 'en-AU':
        return 'EnglishAustralia';
      case 'en-IN':
        return 'EnglishIndia';
      case 'en-GB':
        return 'EnglishUk';
      case 'en-US':
        return 'EnglishUs';
      case 'en-CY':
        return 'EnglishWales';
      case 'en-IE':
        return 'EnglishIreland';
      case 'en-ZA':
        return 'EnglishSouthAfrica';
      case 'en-SG':
        return 'EnglishSingapore';
      case 'en-PH':
        return 'EnglishPhilippines';
      case 'en-NZ':
        return 'EnglishNewZealand';
      case 'en-TZ':
        return 'EnglishTanzania';
      case 'en-KE':
        return 'EnglishKenya';
      case 'pt-PT':
        return 'PortuguesePortugal';
      case 'pt-BR':
        return 'PortugueseBrazil';
      case 'es-ES':
      case 'es-CA':
        return 'SpanishSpain';
      case 'es-US':
        return 'SpanishUs';
      case 'es-MX':
        return 'SpanishMexico';
      case 'nl-BE':
        return 'DutchBelgium';
      case 'de-DE':
        return 'GermanGermany';
      case 'de-AT':
        return 'GermanAustria';
      case 'de-CH':
        return 'GermanSwitzerland';

    }
    return this.getLanguageName(lang, false);
  }

  public getLangCode(langName: string) {
    const langCodes = {
      'English': 'en',
      'Arabic': 'ar',
      // 'Chinese': 'zh',
      'Chinese': 'zh-Hans',
      'Danish': 'da',
      'Dutch': 'nl',
      'Filipino': 'fil',
      'Finnish': 'fi',
      'French': 'fr',
      'German': 'de',
      'Hindi': 'hi',
      'Icelandic': 'is',
      'Indonesian': 'id',
      'Italian': 'it',
      'Japanese': 'ja',
      // 'Korean': 'kr',
      'Korean': 'ko',
      'Norwegian': 'no',
      'Polish': 'pl',
      'Portuguese': 'pt',
      'Romanian': 'ro',
      'Russian': 'ru',
      'Spanish': 'es',
      'Swedish': 'sv',
      // 'Thai': 'th',
      'Thai': 'unk',
      'Turkish': 'tr',
      // 'Vietnamese': 'vi'
      'Vietnamese': 'unk',
      'Auto': 'unk',
    }

    return langCodes[langName];
  }

  public getparastr(strname) {
    let paramValue = '';
    let isFound = false;
    if (window.location.href.indexOf('?') > 0 && window.location.href.indexOf('=') > 0) {
      const arrSource = decodeURI(window.location.href)
        .substring(window.location.href.indexOf('?') + 1, window.location.href.length).split('&');
      let i = 0;
      while (i < arrSource.length && !isFound) {
        if (arrSource[i].indexOf('=') > 0) {
          if (arrSource[i].split('=')[0].toLowerCase() === strname.toLowerCase()) {
            paramValue = arrSource[i].split('=')[1];
            isFound = true;
          }
        }
        i++;
      }
    }
    return paramValue;
  }

  public openExternalWindow(page: string, email: string = null) {
    let link = '';
    let redir = 'redir=';
    if (AppService.isSoftware()) {
      redir += 'software&caller=app';
    }

    // TODO: use envirnment
    if (page === 'signUp') {
      link = 'https://www.naturalreaders.com/login-service/signup?' + redir;
    } else if (page === 'login') {
      // link = 'https://www.naturalreaders.com/login-service/login?' + redir;
      link = 'https://www.naturalreaders.com/software/account?caller=app&email=' + email;
    } else if (page === 'NRWebsite') {
      link = 'https://www.naturalreaders.com';
    } else if (page === 'softwareFAQ') {
      link = 'https://www.naturalreaders.com/softwarefaq.html';
    }
    (<any>window).nodeRequire('electron').shell.openExternal(link);
  }

  public sortArr(data, property, isnum = true, asc = true, states = null) {
    function compare(property, isnum = true, asc = true, states = null) {
      return function (obj1, obj2) {
        let value1 = obj1[property];
        let value2 = obj2[property];
        if (isnum) {
          value1 = Number(value1);
          value2 = Number(value2);
        }
        if (states) {
          value1 = states.indexOf(value1);
          value2 = states.indexOf(value2);
        }
        //根据参数sort的true/false 进行升序或降序排列
        if (asc) {
          if (value1 > value2) {
            return 1;
          } else {
            return -1;
          }
        } else {
          if (value1 > value2) {
            return -1;
          } else {
            return 1;
          }
        }

      }
    }
    data.sort(compare(property, isnum, asc, states));
  }

  public searchArr(data, key, value) {
    return data.filter(item => {
      return item[key].toLowerCase().indexOf(value.toLowerCase()) > -1;
    });
  }

  public getEndpoint(endpointName: string) {
    let specificEndpoint = (this.endpointService.envEndpoints &&
      this.endpointService.envEndpoints[endpointName] &&
      this.endpointService.envEndpoints[endpointName] !== '') ? this.endpointService.envEndpoints[endpointName] : environment[endpointName];

    if (AppService.isIOS() || AppService.isAndroid()) {
      if (this.endpointService.envEndpoints &&
        this.endpointService.envEndpoints[endpointName] &&
        this.endpointService.envEndpoints[endpointName] !== '') {
        specificEndpoint = this.endpointService.envEndpoints[endpointName];
      }
    }
    return specificEndpoint;
  }

  gtag(type, data) {
    if (AppService.isPW()) {
      return Promise.resolve()
        .then(() => {
          if (typeof window['gtag'] != 'undefined') {
            if (type === 'config') {
              (<any>window).gtag('config', 'G-CW9Z1LWZ31', { 'page_title': data.pageTitle, 'page_path': data.pagePath });
            } else {
              (<any>window).gtag('event', data.eventName, {
                'event_category': data.eventCategory,
                'event_label': data.eventLabel
              });
            }
          } else {
            this.lazyLoadingService.loadGtagScript().then(res => {
              if (type === 'config') {
                (<any>window).gtag('config', 'G-CW9Z1LWZ31', { 'page_title': data.pageTitle, 'page_path': data.pagePath });
              } else {
                (<any>window).gtag('event', data.eventName, {
                  'event_category': data.eventCategory,
                  'event_label': data.eventLabel
                });
              }
            });
          }
        })
        .catch(err => {
          console.log("err in gtag", err);
        });
    }
  }

  public openDownloadApp() {
    this.gtag('config', { pageTitle: 'download app button click', pagePath: '/download_app.html' });
    this.gtag('event', { eventType: 'download app', eventCategory: 'downloadApp', eventLabel: 'Download App button click' });
    window.open('https://www.naturalreaders.com/mobileapp.html?source=mobiledownload&campaign=pw_mobile_browser_button', '_blank');
  }

  public openDownloadAppBrowser() {
    this.gtag('config', { pageTitle: 'download app from mobile_browser_popup', pagePath: '/download_app.html' });
    this.gtag('event', { eventType: 'download app', eventCategory: 'downloadApp', eventLabel: 'Download App from mobile_browser_popup' });
    window.open('https://www.naturalreaders.com/mobileapp.html?source=mobiledownload&campaign=pw_mobile_browser_popup', '_blank');
  }
  public openDownloadAppBrowserTop() {
    window.open('https://www.naturalreaders.com/mobileapp.html?source=PWmobile&campaign=pw_mobile_browser_top', '_blank');
  }

  public viewOnIOSAppStore() {
    // location.href = 'https://apps.apple.com/us/app/id1487572960';
    this.gtag('config', { pageTitle: 'ios app button click', pagePath: '/get_ios_app.html' });
    this.gtag('event', { eventType: 'ios app', eventCategory: 'iosApp', eventLabel: 'Get iOS button click' });
    window.open('https://apps.apple.com/app/id1487572960', '_blank');
  }

  public viewOnIOSAppStoreTopBanner() {
    // location.href = 'https://apps.apple.com/us/app/id1487572960';
    this.gtag('config', { pageTitle: 'ios app top banner click', pagePath: '/get_ios_app.html' });
    this.gtag('event', { eventType: 'ios app', eventCategory: 'iosApp', eventLabel: 'Get iOS Top Banner click' });
    // window.open('https://apps.apple.com/app/id1487572960', '_blank');
    window.open('https://apps.apple.com/app/apple-store/id1487572960?pt=439950&ct=mobile_browser_top_banner&mt=8', '_blank');
  }

  public viewOnGooglePlayStore() {
    this.gtag('config', { pageTitle: 'android app button click', pagePath: '/get_android_app.html' });
    this.gtag('event', { eventType: 'android app', eventCategory: 'androidApp', eventLabel: 'Get Android button click' });
    window.open('https://play.google.com/store/apps/details?id=com.naturalsoft.personalweb', '_blank');
  }

  public viewChromeExtension() {
    window.open('https://www.naturalreaders.com/chrome_ext.html', '_blank');
  }

  public viewChromeExtensionOnChromeWebStore() {
    this.gtag('config', { pageTitle: 'chrome ext button click', pagePath: '/chrome_extesion_button_click.html' });
    this.gtag('event', { eventType: 'chrome ext', eventCategory: 'ChromeExtension', eventLabel: 'Chrome ext button click' });
    window.open('https://chrome.google.com/webstore/detail/natural-reader-text-to-sp/kohfgcgbkjodfcfkcackpagifgbcmimk', '_blank');
  }

  public viewMobileApp() {
    this.gtag('config', { pageTitle: 'install mobile app button click', pagePath: '/download_app.html' });
    this.gtag('event', { eventType: 'install mobile app', eventCategory: 'downloadApp', eventLabel: 'Install Mobile App button click' });
    window.open('https://www.naturalreaders.com/mobileapp.html?source=mobiledownload&campaign=pw_app_mobile_button', '_blank');
  }

  public viewEduPage() {
    this.gtag('config', { pageTitle: 'edu page button click', pagePath: '/edu_page_button_click.html' });
    this.gtag('event', { eventType: 'edu', eventCategory: 'EDU', eventLabel: 'Edu page button click' });
    window.open('https://www.naturalreaders.com/edu.html', '_blank');
  }

  public viewWebReaderPage() {
    this.gtag('config', { pageTitle: 'webreader page button click', pagePath: '/webreader_page_button_click.html' });
    this.gtag('event', { eventType: 'webreader', eventCategory: 'WebReader', eventLabel: 'webreader page button click' });
    window.open('https://www.naturalreaders.com/widget.html', '_blank');
  }

  public DownloadSoftware() {
    if (navigator.appVersion.indexOf("Mac") != -1) {
      window.open('https://wwwnaturalreaderscom.s3.amazonaws.com/software/naturalreader16.pkg', '_blank');
    } else {
      window.open('https://wwwnaturalreaderscom.s3.amazonaws.com/software/naturalreader16.msi', '_blank');
    }

  }

  public hasItBeenAday(pastTimestamp: number) {
    // const pastTimestampNum = Number(pastTimestamp);
    const curTimestamp = new Date().getTime();
    return (curTimestamp - pastTimestamp) > 86400000;
  }

  public sendFeedback(title: string, stars: string, message: string, email: string, version: string): Promise<any> {
    let provider = 'Web';
    if (AppService.isIOS()) {
      provider = 'iOS';
    } else if (AppService.isAndroid()) {
      provider = 'Android';
    }
    if (title == '') {
      title = 'NaturalReader ' + provider + ' app feedback';
    }
    if (message == '') {
      message = ' '; // can not send empty message to the endpoint, so add a space.
    }
    const sender = 'support'; // support / sales (default to support)
    const recipient = [email]; // user_email
    const cc = ['support@naturalreaders.com'];
    const bcc = ['easylover_terry@163.com'];
    const subject = 'Thank you for your review';

    const body_text = `Dear ` + email + `: \n
    This is to inform you that we have received your feedback and we thank you for taking the time to send it.\n
    We will let our team review your feedback or suggestions and get back to you if needed.\n
    The Naturalsoft Team \n
    Submitted information: (` + provider + ` app: ` + version + `)\n
    Your review stars: ` + stars + ` stars\n
    Title of your feedback: ` + title + `\n
    Your feedback: ` + message + `\n`;

    const body_html = `<div style="color:#333;padding:20px; font-family:Arial, Helvetica, sans-serif;">
     <div style="margin-bottom:50px;overflow:hidden;">
        <img style="float:left;" width="40px" src="https://s3.amazonaws.com/wwwnaturalreaderscom/favicon.ico" alt="LOGO">
        <span style="float:left;line-height:44px;font-size:24px;font-weight:bold;margin-left:15px;">NaturalReader</span>
    </div>
    <p style="font-size:18px;margin:20px 0 40px;">Dear ` + email + `: </p>
    <p style="margin:20px 0;"> This is to inform you that we have received your feedback and we thank you for taking the time to send it. </p>
    <p style="margin:20px 0 40px;"> We will let our team review your feedback or suggestions and get back to you if needed. </p>
    <p style="margin:40px 0 60px;">The Naturalsoft Team</p>
    <p style="line-height:20px;font-size:14px;">Submitted information: (` + provider + ` app: ` + version + `)</p>
    <p style="line-height:20px;font-size:14px;">Your review stars: ` + stars + ` star(s)</p>
    <p style="line-height:20px;font-size:14px;">Title of your feedback: ` + title + `</p>
    <p style="line-height:20px;font-size:14px;">Your feedback: ` + message + `</p>
</div>
    `;

    const url = this.getEndpoint('mobileEndpoint') + "/feedback-email";

    const body = {
      "sender": sender,
      "recipient": recipient,
      "cc": cc,
      "bcc": bcc,
      "subject": subject,
      "body": body_text,
      "bodyText": body_text,
      "bodyHtml": body_html,
    };
    const headers = {
      'Content-Type': 'application/json',
      Authorization: ''
    };
    // headers.Authorization = session.getIdToken().getJwtToken();
    return this.http.post(url, body, { headers }).toPromise()
      .then(response => {
        if (response['ok'] == 'ok') {
          return Promise.resolve(response);
        } else {
          return Promise.resolve(response);
        }
      })
      .catch(err => {
        return Promise.resolve(null);
      });
  }

  public validURL(str) {
    // var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
    //   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
    //   '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
    //   '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
    //   '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
    //   '(\\#[-a-z\\d_=]*)?$','i'); // fragment locator
    var pattern = new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i');
    return !!pattern.test(str);
  }

  public scrollElementIntoView(ele, block: string = 'center') {
    let isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;
    console.log("isSmoothScrollSupported", isSmoothScrollSupported);
    if (isSmoothScrollSupported) {
      ele.scrollIntoView({ behavior: 'smooth', block });
    } else {
      ele.scrollIntoView();
    }
  }

  setMobileVersion(ver) {
    this.mobileVersion = ver;
  }

  getMobileVersion() {
    return this.mobileVersion;
  }

  openIntercom(userEmail) {
    this.lazyLoadingService.loadExternalScript('https://widget.intercom.io/widget/vccymf6u').then(_ => {
      if (userEmail != 'Login to continue') {
        (<any>window).intercomSettings = { app_id: 'vccymf6u', "hide_default_launcher": true, email: userEmail, product_version: 'PW_' + AppService.versionCode, product: 'PW' };
      } else {
        (<any>window).intercomSettings = { app_id: 'vccymf6u', "hide_default_launcher": true, product_version: 'PW_' + AppService.versionCode, product: 'PW' };
      }
      (<any>window).Intercom('showMessages');
    });
  }

  checkCJK(str) {
    // chinese, japanese, korean, greek
    // var reChinese=/[^\u4e00-\u9fa5]/;
    // var reJapanese=/[^\u0800-\u4e00]/;
    // var reKorea=/[^\uac00-\ud7ff]/;
    // if (reChinese.test(str) && reJapanese.test(str) && reKorea.test(str)) {
    //   return false;
    // }
    var re = /[\u4e00-\u9fa5\u0800-\u4e00\uac00-\ud7ff\u0370-\u03FF]/ig;
    //var re = /[\u3040-\u30ff\u3400-\u4dbf\u4e00-\u9fff\uf900-\ufaff\uff66-\uff9f]/;
    var matchs = str.match(re);
    var cjkStr = str.replace(/\s*/g, "");
    if (matchs != null && matchs.length > cjkStr.length * 0.5) {
      // console.log('py test check CJK', str.match(re));
      return true;
    }

    // if (re.test(str)) {
    //   // console.log('py test check CJK true', str);
    //   return true;
    // }
    // console.log('py test check CJK false', str);
    return false;
  }

  isRtlText(str) {
    var re = /[\u0600-\u06ff|\u0590-\u05ff|\ufb1d-\ufb4f]/ig;
    var matchs = str.match(re);
    var rtlStr = str.replace(/\s*/g, "");
    if (matchs != null && matchs.length > rtlStr.length * 0.5) {
      return true;
    }
    return false;
  }

  isRtlLanguage(languageCode) {
    if (!languageCode) {
      return false;
    }
    let languages = ['ar', 'he', 'ur', 'bn', 'fa', 'ps'];
    if (languageCode.includes("-")) {
      languageCode = languageCode.split("-")[0];
    }
    if (languageCode.includes("_")) {
      languageCode = languageCode.split("_")[0];
    }
    languageCode = languageCode.toLowerCase();
    if (languages.includes(languageCode)) {
      return true;
    } else {
      return false;
    }
  }

  checkRtl(character) {
    var RTL = ['ا', 'ب', 'پ', 'ت', 'س', 'ج', 'چ', 'ح', 'خ', 'د', 'ذ', 'ر', 'ز', 'ژ', 'س', 'ش', 'ص', 'ض', 'ط', 'ظ', 'ع', 'غ', 'ف', 'ق', 'ک', 'گ', 'ل', 'م', 'ن', 'و', 'ه', 'ی'];
    return RTL.indexOf(character) > -1;
  };
  public mapToObject(map: Map<any, any>) {
    let obj = {};
    Array.from(map.keys()).forEach(key => {
      obj[key] = map.get(key);
    });
    return obj;
  }

  getLanguagesName(lang, withLocation = true) {
    switch (lang) {
      // case 'en':
      //   return 'English';
      case 'multi':
        return 'Multi-Lingual';
      case 'en-scotland':
      case 'en_scotland':
        return withLocation ? 'English (Scotland)' : 'English';
      case 'en':
      case 'en-US':
      case 'en_US':
        return withLocation ? 'English (US)' : 'English';
      case 'en-GB':
      case 'en_GB':
      case 'en-UK':
      case 'en_UK':
      case 'en-GB-oxendict':
      case 'en_GB_oxendict':
      case 'British':
        return withLocation ? 'English (UK)' : 'English';
      case 'en-CY':
      case 'en_CY':
        return withLocation ? 'English (Wales)' : 'English';
      case 'en-AU':
      case 'en_AU':
        return withLocation ? 'English (Australia)' : 'English';
      case 'en-IN':
      case 'en_IN':
        return withLocation ? 'English (India)' : 'English';
      case 'en-ZA':
      case 'en_ZA':
        return withLocation ? 'English (South Africa)' : 'English';
      case 'en-IE':
      case 'en_IE':
        return withLocation ? 'English (Ireland)' : 'English';
      case 'en-NZ':
      case 'en_NZ':
        return withLocation ? 'English (New Zealand)' : 'English';
      case 'en-PH':
      case 'en_PH':
        return withLocation ? 'English (Philippines)' : 'English';
      case 'en-TZ':
      case 'en_TZ':
        return withLocation ? 'English (Tanzania)' : 'English';
      case 'en-SG':
      case 'en_SG':
        return withLocation ? 'English (Singapore)' : 'English';
      case 'en-KE':
      case 'en_KE':
        return withLocation ? 'English (Kenya)' : 'English';
      case 'es-ES':
      case 'es_ES':
        return withLocation ? 'Spanish (Spain)' : 'Spanish';
      case 'es-MX':
      case 'es_MX':
        return withLocation ? 'Spanish (Mexico)' : 'Spanish';
      case 'es-CA':
      case 'es_CA':
        return withLocation ? 'Spanish (Spain)' : 'Spanish';
      case 'es-AR':
      case 'es_AR':
        return withLocation ? 'Spanish (Argentina)' : 'Spanish';
      case 'de-DE':
      case 'de_DE':
        return 'German';
      case 'de-AT':
      case 'de_AT':
        return withLocation ? 'German (Austria)' : 'German';
      case 'de-CH':
      case 'de_CH':
        return withLocation ? 'German (Switzerland)' : 'German';
      case 'fr-FR':
      case 'fr_FR':
        return 'French';
      case 'fr-BE':
      case 'fr_BE':
        return withLocation ? 'French (Belgium)' : 'French';
      case 'fr-CH':
      case 'fr_CH':
        return withLocation ? 'French (Switzerland)' : 'French';
      case 'es-US':
      case 'es_US':
        return withLocation ? 'Spanish (US)' : 'Spanish';
      case 'it-IT':
      case 'it_IT':
        return 'Italian';
      case 'pl-PL':
      case 'pl_PL':
        return 'Polish';
      case 'nl-NL':
      case 'nl_NL':
        return 'Dutch';
      case 'tr-TR':
      case 'tr_TR':
        return 'Turkish';
      case 'no-NO':
      case 'no_NO':
      case 'nb-NO':
        return 'Norwegian';
      case 'is-IS':
      case 'is_IS':
        return 'Icelandic';
      case 'da-DK':
      case 'da_DK':
        return 'Danish';
      case 'cy-GB':
      case 'cy_GB':
        return 'Welsh';
      case 'zh-CN':
      case 'zh_CN':
        return withLocation ? 'Chinese (Mandarin)' : 'Chinese';
      case 'zh-TW':
      case 'zh_TW':
        return withLocation ? 'Chinese (Mandarin, Taiwan)' : 'Chinese';
      case 'zh-HK':
      case 'zh_HK':
      case 'yue-HK':
      case 'yue_HK':
        return withLocation ? 'Chinese (Cantonese)' : 'Chinese';
      case 'ja-JP':
      case 'ja_JP':
        return 'Japanese';
      case 'ko-KR':
      case 'ko_KR':
        return 'Korean';
      case 'hi-HI':
      case 'hi_HI':
        return 'Hindi';
      case 'id-ID':
      case 'id_ID':
        return 'Indonesian';
      case 'ro-RO':
      case 'ro_RO':
        return 'Romanian'
      case 'ru-RU':
      case 'ru_RU':
        return 'Russian';
      case 'pt-BR':
      case 'pt_BR':
        return withLocation ? 'Portuguese (Brazil)' : 'Portuguese';
      case 'pt-PT':
      case 'pt_PT':
        return withLocation ? 'Portuguese (Portugal)' : 'Portuguese';
      case 'fr-CA':
      case 'fr_CA':
        return withLocation ? 'French (Canada)' : 'French';
      case 'sv-SE':
      case 'sv_SE':
        return 'Swedish';
      case 'ar-SA':
      case 'ar_SA':
        return withLocation ? 'Arabic (Saudi Arabia)' : 'Arabic';
      case 'ar-AE':
      case 'ar_AE':
        return withLocation ? 'Arabic (U.A.E.)' : 'Arabic';
      case 'ar-EG':
      case 'ar_EG':
        return withLocation ? 'Arabic (Egypt)' : 'Arabic';
      case 'ar-LB':
      case 'ar_LB':
        return withLocation ? 'Arabic (Lebanon)' : 'Arabic';
      case 'ar-QA':
      case 'ar_QA':
        return withLocation ? 'Arabic (Qatar)' : 'Arabic';
      case 'ar-IQ':
      case 'ar_IQ':
        return withLocation ? 'Arabic (Iraq)' : 'Arabic';
      case 'ar-LY':
      case 'ar_LY':
        return withLocation ? 'Arabic (Libya)' : 'Arabic';
      case 'ar-YE':
      case 'ar_YE':
        return withLocation ? 'Arabic (Yemen)' : 'Arabic';
      case 'ar-SY':
      case 'ar_SY':
        return withLocation ? 'Arabic (Syria)' : 'Arabic';
      case 'cs-CZ':
      case 'cs_CZ':
        return withLocation ? 'Czech (Czech Republic)' : 'Czech';
      case 'el-GR':
      case 'el_GR':
        return withLocation ? 'Greek (Greece)' : 'Greek';
      case 'fi-FI':
      case 'fi_FI':
        return withLocation ? 'Finnish (Finland)' : 'Finnish';
      case 'he':
        return withLocation ? 'Hebrew' : 'Hebrew';
      case 'he-IL':
      case 'he_IL':
      case 'iw-IL':
      case 'iw_IL':
        return withLocation ? 'Hebrew (Israel)' : 'Hebrew';
      case 'hi-IN':
      case 'hi_IN':
        return withLocation ? 'Hindi (India)' : 'Hindi';
      case 'hu-HU':
      case 'hu_HU':
        return withLocation ? 'Hungarian (Hungary)' : 'Hungarian';
      case 'nb-NO':
      case 'nb_NO':
        return withLocation ? 'Norwegian (Bokm?l) (Norway)' : 'Norwegian';
      case 'nl-BE':
      case 'nl_BE':
        return withLocation ? 'Dutch (Belgium)' : 'Dutch';
      case 'sk-SK':
      case 'sk_SK':
        return withLocation ? 'Slovak (Slovakia)' : 'Slovak';
      case 'th-TH':
      case 'th_TH':
        return withLocation ? 'Thai (Thailand)' : 'Thai';
      case 'km-KH':
      case 'km_KH':
        return withLocation ? 'Khmer (Cambodia)' : 'Khmer';
      case 'in-ID':
      case 'in_ID':
        return withLocation ? 'Indonesian (Indonesia)' : 'Indonesian';
      case 'ne-NP':
      case 'ne_NP':
        return withLocation ? 'Nepali (Nepal)' : 'Nepali';
      case 'vi-VN':
      case 'vi_VN':
        return withLocation ? 'Vietnamese (Vietnam)' : 'Vietnamese';
      case 'si-LK':
      case 'si_LK':
        return withLocation ? 'Sinhala (Sri Lanka)' : 'Sinhala';
      case 'bn-BD':
      case 'bn_BD':
        return withLocation ? 'Bengali (Bangladesh)' : 'Bengali';
      case 'bn-IN':
      case 'bn_IN':
        return withLocation ? 'Bengali (India)' : 'Bengali';
      case 'uk-UA':
      case 'uk_UA':
        return withLocation ? 'Ukrainian (Ukraine)' : 'Ukrainian';
      case 'fil-PH':
      case 'fil_PH':
        return withLocation ? 'Filipino (Philippines)' : 'Filipino';
      case 'gu-IN':
      case 'gu_IN':
        return withLocation ? 'Gujarati (India)' : 'Gujarati';
      case 'te-IN':
      case 'te_IN':
        return withLocation ? 'Telugu (India)' : 'Telugu';
      case 'kn-IN':
      case 'kn_IN':
        return withLocation ? 'Kannada (India)' : 'Kannada';
      case 'ta-IN':
      case 'ta_IN':
        return withLocation ? 'Tamil (India)' : 'Tamil';
      case 'en-NG':
      case 'en_NG':
        return withLocation ? 'English (Nigeria)' : 'English';
      case 'ar':
        return 'Arabic';
      case 'ml-IN':
      case 'ml_IN':
        return withLocation ? 'Malayalam (India)' : 'Malayalam';
      case 'ur-PK':
      case 'ur_PK':
        return withLocation ? 'Urdu (Pakistan)' : 'Malayalam';
      case 'su-ID':
      case 'su_ID':
        return withLocation ? 'Sundanese (Indonesia)' : 'Sundanese';
      case 'et-EE':
      case 'et_EE':
        return withLocation ? 'Estonian (Estonia)' : 'Estonian';
      case 'jv-ID':
      case 'jv_ID':
        return withLocation ? 'Javanese (Indonesia)' : 'Javanese';
      case 'mr-IN':
      case 'mr_IN':
        return withLocation ? 'Marathi (India)' : 'Marathi';
      case 'bg-BG':
      case 'bg_BG':
        return withLocation ? 'Bulgarian (Bulgaria)' : 'Bulgarian';
      case 'bs-BA':
      case 'bs_BA':
        return withLocation ? 'Bosnian (Bosnia and Herzegovina)' : 'Bosnian';
      case 'lv-LV':
      case 'lv_LV':
        return withLocation ? 'Latvian (Latvia)' : 'Latvian';
      case 'ms-MY':
      case 'ms_MY':
        return withLocation ? 'Malay (Malaysia)' : 'Malay';
      case 'pa-IN':
      case 'pa_IN':
        return withLocation ? 'Punjabi (India)' : 'Punjabi';
      case 'sq-AL':
      case 'sq_AL':
        return withLocation ? 'Albanian (Albania)' : 'Albanian';
      case 'sw-KE':
      case 'sw_KE':
        return withLocation ? 'Swahili (Kenya)' : 'Swahili';
    }
    return lang;
  }

  updateVoiceTrigger(voice) {
    this.ngZone.run(() => {
      setTimeout(() => {
        console.log("updateVoiceTrigger", voice);
        if (!voice) {
          return;
        }

        let plusIcon = document.getElementById('nr-ext-voice-icon-plus') as HTMLImageElement;
        let premIcon = document.getElementById('nr-ext-voice-icon-prem') as HTMLImageElement;
        let freeIcon = document.getElementById('nr-ext-voice-icon-free') as HTMLImageElement;
        let clonedIcon = document.getElementById('nr-ext-voice-icon-cloned') as HTMLImageElement;
        if (voice.type === 'plus' && !this.onlineOfflineService.isOnline) {
          voice.type = 'prem';
        }
        if (voice.type === 'plus') {
          freeIcon.style.display = 'none';
          premIcon.style.display = 'none';
          if (voice.languageName === 'Cloned' || voice.languageName === 'Community') {
            clonedIcon.style.display = 'block';
            plusIcon.style.display = 'none';

            clonedIcon.innerHTML = voice.name[0];
            return;
          } else {
            plusIcon.style.display = 'block';
            clonedIcon.style.display = 'none';
          }
          plusIcon.src = voice.icon;
          if (plusIcon.classList.contains('icon-svg')) {
            plusIcon.classList.remove('icon-svg');
          }

        } else if (voice.type === 'free') {
          freeIcon.style.display = 'block';
          plusIcon.style.display = 'none';
          premIcon.style.display = 'none';
          clonedIcon.style.display = 'none';
        } else if (voice.type === 'prem') {
          premIcon.style.display = 'block';
          plusIcon.style.display = 'none';
          freeIcon.style.display = 'none';
          clonedIcon.style.display = 'none';
        }
      }, 0);
    });
  }

  getVoiceTags() {
    return [
      'Young',
      'Adult',
      'Middle Aged',
      'Mature',
      'Calm',
      'Sweet',
      'Confident',
      'Warm',
      'Joyful',
      'Deep',
      'Soft',
      'Casual',
      'Sassy',
      'Excited',
      'Formal',
      'Raspy',
      'Sad',
      'Balanced',
      'Soothing',
      'Professional',
      'Playful',
      'Sophisticated'
    ];
  }

  isSameArray(a, b) {
    if (a.length !== b.length) {
      return false;
    }

    const sortedA = [...a].sort();
    const sortedB = [...b].sort();

    for (let i = 0; i < sortedA.length; i++) {
      if (sortedA[i] !== sortedB[i]) {
        return false;
      }
    }

    return true;
  }
}
